import { savvyGoldClient, savvyGoldApiWraper } from './savvy-gold-client'
import { createMethod } from './tools'

export const api = {
  savvyGold: createMethod(savvyGoldClient, savvyGoldApiWraper),
}
